import { render, staticRenderFns } from "./LogoHorizontal.vue?vue&type=template&id=d98207b6"
import script from "./LogoHorizontal.vue?vue&type=script&lang=js"
export * from "./LogoHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports